// Wrapper for localStorage

const PREFIX = '5ugc_';

export const localStorageService = {
  /**
   * Get item from localStorage
   * @param {string} key
   * @param {*} defaultValue
   * @returns {*}
   */
  get(key, defaultValue = null) {
    try {
      const item = localStorage.getItem(PREFIX + key);
      return item ? JSON.parse(item) : defaultValue;
    } catch {
      return defaultValue;
    }
  },

  /**
   * Set item in localStorage
   * @param {string} key
   * @param {*} value
   */
  set(key, value) {
    try {
      localStorage.setItem(PREFIX + key, JSON.stringify(value));
    } catch (error) {
      console.warn('localStorage set error:', error);
    }
  },

  /**
   * Remove item from localStorage
   * @param {string} key
   */
  remove(key) {
    localStorage.removeItem(PREFIX + key);
  },

  /**
   * Clear all 5UGC items from localStorage
   */
  clear() {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  },

  /**
   * Check if key exists
   * @param {string} key
   * @returns {boolean}
   */
  has(key) {
    return localStorage.getItem(PREFIX + key) !== null;
  },
};
